import { Button, Image, Link, Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/react';
import { HiChevronDown, HiOutlineChatAlt2, HiOutlineMail } from 'react-icons/hi';

import { trpc } from '../config/trpc';
import { useSupportChat } from '../hooks/support/useSupportChat';
import { useCustomerAsset } from '../hooks/tenant/useCustomerAsset';
import { EmailRequestProps } from '../hooks/useEmailRequest';

export const SupportButton = ({ requestId, type }: EmailRequestProps) => {
  const { handleChatSupport } = useSupportChat({ requestId });
  const supportIconSrc = useCustomerAsset('supportIcon');
  const { data: prefilledSupportEmailLink } = trpc.getPrefilledSupportEmail.useQuery(
    { requestId },
    { enabled: !!requestId, refetchOnWindowFocus: false },
  );

  return (
    <Menu>
      <MenuButton
        variant={type === 'Update' ? 'ghost' : undefined}
        // `undefined` rather than a `Show`: `leftIcon` is a prop, and passing an empty element
        // would still reserve the icon's margin next to the label.
        leftIcon={supportIconSrc ? <Image src={supportIconSrc} /> : undefined}
        rightIcon={<HiChevronDown />}
        as={Button}
      >
        Support
      </MenuButton>
      <MenuList>
        <MenuItem as={Link} href={prefilledSupportEmailLink} icon={<HiOutlineMail />} isExternal>
          Help with Request
        </MenuItem>
        <MenuItem icon={<HiOutlineChatAlt2 />} onClick={handleChatSupport}>
          Chat
        </MenuItem>
      </MenuList>
    </Menu>
  );
};
